import React from "react";
import "../styles/OurBrands.css";
import b1 from "../assets/images/Brand/b1.jpg";
import b2 from "../assets/images/Brand/b2.jpg";
import b3 from "../assets/images/Brand/b3.jpg";
import b4 from "../assets/images/Brand/b4.jpg";
import b5 from "../assets/images/Brand/b5.jpg";
import b6 from "../assets/images/Brand/b6.jpg";
import b7 from "../assets/images/Brand/b7.jpg";
import b8 from "../assets/images/Brand/b8.jpg";
import b9 from "../assets/images/Brand/b9.jpg";
import b10 from "../assets/images/Brand/b10.jpg";
import b11 from "../assets/images/Brand/b11.jpg";
import b12 from "../assets/images/Brand/b12.jpg";
// 👇 12 brands ka data (image + link)
const brands = [
  { img:  b1,  },
  { img:  b2,  },
  { img:  b3,  },
  { img:  b4, },    
  { img:  b5,  },
  { img:  b6,  },
  { img:  b7,  },
  { img:  b8,},
  { img:  b9, },
  { img:  b10, },
  { img:  b11,  },
  { img:  b12,  },
];

function OurBrands() {
  return (
    <section className="our-brands">
      <h2>Our Brands</h2>
      <div className="brands-grid">
        {brands.map((brand, index) => (
          <a
            key={index}
            href={brand.link}
            target="_blank"
            rel="noopener noreferrer"
            className="brand-card"
          >
            <img src={brand.img} alt={`Brand ${index + 1}`} />
          </a>
        ))}
      </div>
    </section>
  );
}

export default OurBrands;
